import UpgradeCycleModal from "./UpgradeCycleModalContainer";

export default UpgradeCycleModal;
